import { useEffect, useRef } from 'react'
import type { ChatMessage } from '@/types/chat'
import { MessageBubble } from './MessageBubble'
import styles from './ChatCanvas.module.css'

interface ChatCanvasProps {
  messages: ChatMessage[]
  isBusy: boolean
}

export function ChatCanvas({ messages, isBusy }: ChatCanvasProps) {
  const bottomRef = useRef<HTMLDivElement>(null)
  const lastMessageLength = messages[messages.length - 1]?.text.length ?? 0

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' })
  }, [messages.length, lastMessageLength, isBusy])

  // Once tokens are streaming into a live bubble, the standalone typing
  // indicator is redundant — hide it to avoid a double "is typing" cue.
  const isStreaming = messages.some((message) => message.streaming)

  return (
    <div className={styles.root} role="log" aria-live="polite" aria-relevant="additions">
      <div className={styles.stream}>
        {messages.map((message) => (
          <MessageBubble key={message.id} message={message} />
        ))}
        {isBusy && !isStreaming && (
          <MessageBubble
            message={{ id: 'typing', role: 'agent', text: '', timestamp: new Date(), pending: true }}
          />
        )}
        <div ref={bottomRef} />
      </div>
    </div>
  )
}
